export enum HistoryStateType {
    OrderStateLog = 1,
    PrescriptionStateLog = 2,
    GenericalOrderLog = 3
}